import {
  Alert,
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  FormControl,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useMediaQueries } from '@hooks';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import dayjs from 'dayjs';
import Link from 'next/link';
import React, { useState, useEffect } from 'react';

const Stepper_C = ({
  onSubmit = () => {},
  store,
  type,
  stores,
}) => {
  const { locale } = useRouter();
  const { isMobile } = useMediaQueries();
  const { t } = useTranslation();

  const [enableSubmit, setEnableSubmit] = useState(false);
  const [formValues, setFormValues] = useState({
    name: null,
    surname: null,
    email: null,
    phone: '',
    date: null,
    time: null,
    store: store ?? '',
    city: null,
    location: null,
    type: type,
    number: null,
    message: null,
    lang: locale,
  });
  const [activeStep, setActiveStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const inputCls = classnames(
    'flex flex-col text-xl !tracking-widest',
    '! text-black p-0 m-0',
  );
  const sx = {
    '& .MuiInputBase-root, .MuiInputLabel-root': {
      color: '#000 !important',
    },
  };
  const stepFields = {
    dateForm: ['date', 'time', 'store'],
    personalInfoForm: [
      'name',
      'surname',
      'email',
      'phone',
      'number',
    ],
  };
  const generateTimeSlots = () => {
    const times = [];
    for (let hour = 8; hour <= 22; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        times.push(
          `${String(hour).padStart(2, '0')}:${String(
            minute,
          ).padStart(2, '0')}`,
        );
      }
    }
    return times.map((time, index) => ({ label: time, id: index }));
  };
  const steps = [
    {
      id: 'dateForm',
      label: t('forms.select_date_place'),
      isOptional: false,
      component: (
        <Box
          component={'form'}
          id="dateForm"
          onSubmit={(e) => handleNext(e)}
        >
          {/* GIORNO + ORA */}
          <div className="flex flex-col w-full space-y-4 lg:flex-row lg:space-x-8 lg:space-y-0">
            <FormControl
              className="space-y-4"
              fullWidth
              sx={sx}
              error={!formValues?.date}
            >
              <span className={classnames('label')}>
                {t('drawers.book_product.steps.day.name')}
              </span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disablePast={true}
                  inputFormat="DD-MM-YYYY"
                  value={formValues?.date}
                  onChange={(val) => {
                    setFormValues({
                      ...formValues,
                      date: dayjs(val),
                    });
                    if (val) {
                      setErrorMessage(null);
                    }
                  }}
                  sx={{
                    '.MuiDayCalendar-weekDayLabel': {
                      color: '#ad1457',
                    },
                    '& .MuiPickersDay-root.Mui-disabled:not(.Mui-selected)':
                      {
                        color: '#FF0000 !important', // Force override with !important
                        backgroundColor: '#FFE5E5', // Optional: background color for disabled days
                      },
                    '& .MuiPickersDay-root.Mui-disabled:not(.Mui-selected):hover':
                      {
                        backgroundColor: '#FFC0C0', // Optional: color when hovering over disabled days
                      },
                  }}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl className="space-y-4 " fullWidth sx={sx}>
              <span className={classnames('label')}>
                {t('drawers.book_product.steps.hour.name')}
              </span>

              <Autocomplete
                placeholder="Slot"
                disableClearable
                id="combo-box-demo"
                value={formValues?.time}
                onChange={(val) => {
                  return setFormValues({
                    ...formValues,
                    time:
                      val?.target?.value || val?.target?.innerHTML,
                  });
                }}
                options={generateTimeSlots()}
                renderInput={(params) => (
                  <TextField required {...params} />
                )}
              />
            </FormControl>
          </div>
          {/* STORE */}
          <FormControl
            className="w-full mx-auto my-4 space-y-4"
            sx={sx}
          >
            <span className={classnames('label lg:mx-auto')}>
              {t(
                'drawers.book_product.steps.add_to_cart.labels.where',
              )}
            </span>

            <Select
              fullWidth
              required
              value={formValues?.store}
              onChange={(e) => handleStoreChange(e.target.value)}
              sx={{
                boxShadow: 'none',
                '.MuiSelect-select': {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                },
                '.MuiInputBase-root': {},
              }}
              className={classnames(
                'flex flex-col text-xl tracking-widest',
                ' border-none shadow-none outline-none',
                ' fill-white text-black',
              )}
            >
              {stores?.map(({ attributes }, i) => {
                const { name, slug, city, location } = attributes;
                return (
                  <MenuItem
                    key={i}
                    value={slug}
                    className="flex flex-col items-center py-4 text-xl tracking-widest"
                  >
                    <span className="text-xs italic text-primary-500">
                      {city?.data?.attributes?.name}
                    </span>
                    <span className="font-medium">{name}</span>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          {/* TIPOLOGIA */}
          <FormControl
            className="w-full mx-auto mb-8 space-y-4"
            sx={sx}
            required
          >
            <span className={classnames('label mx-auto')}>
              {t('forms.type')}
            </span>

            <ButtonGroup
              disableElevation
              className="space-x-2 lg:space-x-4"
              aria-label="Disabled elevation buttons"
            >
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  return setFormValues({
                    ...formValues,
                    type: 'table',
                  });
                }}
                className={classnames(
                  'h-12 rounded-none  tracking-widest text-black',
                  'transition-colors duration-300 ease-in-out hover:bg-primary/90 hover:text-white',
                  {
                    'bg-primary text-white':
                      formValues?.type === 'table',
                  },
                )}
              >
                {t('forms.table')}
              </Button>
              <Button
                fullWidth
                onClick={() => {
                  return setFormValues({
                    ...formValues,
                    type: 'event',
                  });
                }}
                variant="contained"
                className={classnames(
                  'h-12 rounded-none  tracking-widest text-black',
                  'transition-colors duration-300 ease-in-out  hover:bg-secondary/90 hover:text-white',
                  {
                    'bg-secondary text-white':
                      formValues?.type === 'event',
                  },
                )}
              >
                {t('forms.event')}
              </Button>
            </ButtonGroup>
          </FormControl>
        </Box>
      ),
    },
    {
      id: 'personalInfoForm',
      label: t('forms.insert_personal_data'),
      isOptional: false,
      component: (
        <Box
          component={'form'}
          id={'registryForm'}
          onSubmit={(e) => handleNext(e)}
        >
          {/* NAME + SURNAME */}
          <div className="flex flex-col w-full space-y-4 lg:flex-row lg:space-x-8 lg:space-y-0">
            <FormControl
              fullWidth
              className="space-y-4 bg-transparent"
              sx={sx}
            >
              <span className={classnames('label')}>
                {t('forms.name')}
              </span>
              <TextField
                required
                fullWidth
                inputProps={{ maxLength: 80 }}
                value={formValues?.name}
                placeholder={t('forms.name')}
                onChange={(val) => {
                  return setFormValues({
                    ...formValues,
                    name: val?.target?.value,
                  });
                }}
              />
            </FormControl>
            <FormControl className="space-y-4 " fullWidth sx={sx}>
              <span className={classnames('label')}>
                {t('forms.surname')}
              </span>
              <TextField
                required
                fullWidth
                inputProps={{ maxLength: 80 }}
                value={formValues?.surname}
                placeholder={t('forms.surname')}
                onChange={(val) => {
                  return setFormValues({
                    ...formValues,
                    surname: val?.target?.value,
                  });
                }}
              />
            </FormControl>
          </div>
          {/* EMAIL + PHONE */}
          <div className="flex flex-col w-full space-y-4 my-4 lg:flex-row lg:space-x-8 lg:space-y-0">
            <FormControl className="space-y-4" fullWidth sx={sx}>
              <span className={classnames('label')}>Email</span>
              <TextField
                required
                fullWidth
                inputProps={{ maxLength: 120 }}
                placeholder="your@email.it"
                value={formValues?.email}
                onChange={(val) => {
                  return setFormValues({
                    ...formValues,
                    email: val?.target?.value,
                  });
                }}
              />
            </FormControl>
            <FormControl className="space-y-4 " fullWidth sx={sx}>
              <span className={classnames('label')}>
                {t('forms.phone')}
              </span>
              <TextField
                required
                fullWidth
                placeholder={t('forms.control.ten_digits')}
                value={formValues?.phone}
                inputProps={{ pattern: '[0-9]*' }}
                onChange={(val) => {
                  const phone = val?.target?.value;

                  if (!phone?.length) {
                    setFormValues({
                      ...formValues,
                      phone: '',
                    });
                  }

                  if (/^\d+$/.test(phone)) {
                    setFormValues({
                      ...formValues,
                      phone,
                    });
                  }
                }}
              />
            </FormControl>
          </div>
          {/* PERSON */}
          <div className="flex flex-col w-full space-y-4 lg:flex-row lg:space-x-8 lg:space-y-0">
            <FormControl className="space-y-4" fullWidth sx={sx}>
              <span className={classnames('label')}>
                {t('forms.people')}
              </span>
              <TextField
                required
                fullWidth
                type="number"
                value={formValues?.number}
                inputProps={{
                  maxLength: 100,
                  min: 1,
                  max: 100,
                }}
                placeholder="1"
                onChange={(val) => {
                  return setFormValues({
                    ...formValues,
                    number: val?.target?.value,
                  });
                }}
              />
            </FormControl>
          </div>
        </Box>
      ),
    },
    {
      id: 'messageForm',
      label: t('forms.leave_message'),
      isOptional: true,
      component: (
        <Box
          component={'form'}
          id={'messageForm'}
          onSubmit={(e) => onSubmit(e, formValues)}
        >
          {/* MESSAGE */}
          <FormControl
            className="w-full mx-auto my-4 space-y-4"
            fullWidth
            sx={sx}
          >
            <span className={classnames('label mx-auto')}>
              {t('forms.message')}
            </span>

            <TextField
              inputProps={{ maxLength: 800 }}
              placeholder={t('forms.leave_message')}
              multiline
              fullWidth
              className={classnames(inputCls, 'text-black')}
              rows={4}
              onChange={(val) => {
                return setFormValues({
                  ...formValues,
                  message: val?.target?.value,
                });
              }}
            />
          </FormControl>
          <>
            {locale === 'it' && (
              <div className="text-sm body">
                Letta l'
                <Link
                  href="/privacy-policy"
                  className="px-0 underline text-primary underline-offset-2"
                >
                  informativa privacy
                </Link>
                , i suoi dati saranno trattati per gestire la
                prenotazione e/o per darvi le informazioni
                richieste.
              </div>
            )}

            {locale === 'en' && (
              <div className=" text-sm body">
                Your data will be processed to manage the
                reservation and/or to give you the requested
                information. Read
                <Link
                  href="/privacy-policy"
                  className="underline text-primary underline-offset-2"
                >
                  privacy disclaimer
                </Link>
              </div>
            )}
          </>
        </Box>
      ),
    },
  ];

  const validateStepFields = (stepId) => {
    const fieldsToValidate = stepFields[stepId];
    if (fieldsToValidate) {
      const invalidField = fieldsToValidate.find(
        (field) => !formValues[field],
      );
      if (invalidField) {
        setErrorMessage(t('forms.error_missing_fields'));
        return false;
      }
    }
    setErrorMessage(null);
    return true;
  };

  const handleNext = (e) => {
    e.preventDefault();

    const currentStep = steps[activeStep];
    if (!validateStepFields(currentStep.id)) return;

    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const handleStoreChange = (slug) => {
    const selectedStore = stores?.find(
      ({ attributes }) => attributes.slug === slug,
    );
    if (selectedStore) {
      const { city, location } = selectedStore.attributes;
      setFormValues((prev) => ({
        ...prev,
        store: slug,
        city: city?.data?.attributes?.name,
        location: location?.data?.attributes?.name,
      }));
    }
  };
  useEffect(() => {
    setFormValues((prev) => ({
      ...prev,
      store:
        store &&
        stores?.some(({ attributes }) => attributes?.slug === store)
          ? store
          : prev.store,
      type: type || prev.type,
    }));
  }, [store, stores, type]);
  useEffect(() => {
    const allFields = Object.keys(stepFields).flatMap(
      (key) => stepFields[key],
    );
    const requiredFields = allFields.filter(
      (field) => formValues[field] !== undefined,
    );
    setEnableSubmit(
      requiredFields.every((field) => formValues[field]),
    );
  }, [formValues]);

  return (
    <div className="md:max-w-3xl w-full mx-auto">
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        sx={{
          '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
            color: '#30231f !important',
          },
          '& .MuiStepLabel-iconContainer.Mui-disabled.MuiStepLabel-alternativeLabel svg':
            {
              fill: '#da5f06 !important',
              opacity: 0.6,
            },
        }}
      >
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div className="my-8 md:space-y-12">
        {steps[activeStep]?.component}
      </div>

      {errorMessage && (
        <Alert severity="error" className="mb-8">
          {errorMessage}
        </Alert>
      )}

      <div className="flex">
        <Button
          disabled={activeStep === 0}
          onClick={() => setActiveStep((prev) => prev - 1)}
          fullWidth
          color="primary"
          className="mr-1"
          variant="outlined"
        >
          {t('buttons.back')}
        </Button>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleNext}
          disabled={
            activeStep === steps.length - 1 && !enableSubmit
          }
          type="submit"
          form={steps[activeStep]?.id}
          sx={{
            backgroundColor: '#da5f06 !important',
            '&:hover': {
              backgroundColor: '#ae4c05 !important',
            },
          }}
        >
          {activeStep === steps.length - 1
            ? t('buttons.send')
            : t('buttons.next')}
        </Button>
      </div>
    </div>
  );
};

export default Stepper_C;
